export const MAINTENANCE_STATUS_RECEIVED = "MAINTENANCE_STATUS_RECEIVED";
export const MAINTENANCE_DETECTED = "MAINTENANCE_DETECTED";
